import { useState } from "react"
import { AnimatePresence } from "framer-motion"
import styled from "styled-components"

import { INTRO_START } from "../../shared/constants"
import IntroScreen from "../../shared/components/IntroScreen"
import Parallax from "./Parallax"
import Hint from "../../shared/components/Hint"
import Menu from "../../shared/components/Menu"

const MenuDark = styled(Menu)`
  color: #595959;
`

const App = () => {
  const [appState, setAppState] = useState(INTRO_START)
  const [isHintVisible, setIsHintVisible] = useState(true)

  return (
    <AnimatePresence>
      <Parallax
        key={"parallax"}
        appState={appState}
        isHintVisible={isHintVisible}
        setIsHintVisible={setIsHintVisible}
      />

      {appState !== INTRO_START &&
        (isHintVisible ? (
          <Hint key={"Hint"} onClose={() => setIsHintVisible(false)} />
        ) : (
          <MenuDark key={"Menu"} onClose={() => setAppState(INTRO_START)} hasGradient={false} />
        ))}

      {appState === INTRO_START && <IntroScreen key={"IntroScreen"} setAppState={setAppState} />}
    </AnimatePresence>
  )
}

export default App
